// Yoast FAQ block
$(function () {
    $('.schema-faq').addClass('schema-faq-accordion');
    $('.schema-faq-accordion .schema-faq-question').click(function () {
        if ($(this).siblings('.schema-faq-answer').is(':visible')) {
            $(this).removeClass('faq-q-open');
            $(this).siblings('.schema-faq-answer').removeClass('faq-a-open').slideUp();
            $(this).parent().removeClass('faq-s-open');
        } else {
            $(this).addClass('faq-q-open');
            $(this).siblings('.schema-faq-answer').addClass('faq-a-open').slideDown();
            $(this).parent().addClass('faq-s-open');
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/routes/yoastFAQs.js